import { render } from "./base-message.vue?vue&type=template&id=44fa3b8d&ts=true"
import script from "./base-message.vue?vue&type=script&lang=ts"
export * from "./base-message.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__